import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { history } from 'store';
import SweetAlert from 'react-bootstrap-sweetalert';
import IntlMessages from 'util/IntlMessages';
import ListRowImage from 'components/listRowImage';
import ListRowFavourite from 'components/ListRowFavourite';
import ListRowCheckbox from 'components/ListRowCheckbox';
import ListRowData from 'components/ListRowData';
import ListRowDropdown from 'components/ListRowDropdown';
import ProjectCostPriorityEdit from '../../projectCostPriorityMaintenance/projectCostPriorityEdit/index';
import {
    addFavouriteProjectCostPriority,
    onProjectCostPrioritySelect,
    onDeleteProjectCostPriority,
    onEditProjectCostPriority,
    selectProjectCostPriority,
} from 'actions/projectCostPriority';

const ProjectCostPriorityRow = (props) => {
    const dispatch = useDispatch();
    const [menuState, setMenuState] = useState(false);
    const [projectCostPriority, setProjectCostPriority] = useState(props.projectCostPriority);
    const [deleteProjectCostPriorityCheck, setDeleteProjectCostPriorityCheck] = useState(false);
    const width = useSelector(state => state.settings.width);
    // const { projectCostPriority } = props;

    useEffect(() => {
        setProjectCostPriority(props.projectCostPriority);
    }, [props]);

    const { name, starred } = projectCostPriority;
    const options = [
        'Edit',
        'Delete',
    ];

    const projectCostPriorityOptionToggle = () => {
        setMenuState(!menuState);
    };

    const deleteProjectCostPriority = (projectCostPriority) => {
        dispatch(onDeleteProjectCostPriority(projectCostPriority?.id));
    };

    const editProjectCostPriority = () => {
        setMenuState(false);
        dispatch(onEditProjectCostPriority(projectCostPriority));
    };

    return (
        <div className="contact-item">
            <ListRowCheckbox selected={projectCostPriority.selected} onClick={() => dispatch(onProjectCostPrioritySelect(projectCostPriority))} />
            <ListRowFavourite width={width} onClick={() => dispatch(addFavouriteProjectCostPriority(projectCostPriority))} starred={starred} />
            <ListRowImage width={width} data={projectCostPriority} />
            <ListRowData lineOne={name} />
            <ListRowDropdown
                menuState={menuState}
                toggle={projectCostPriorityOptionToggle}
                options={options}
                dropdownItems={options.map(option =>
                    <DropdownItem key={option} onClick={() => {
                        if (option === 'Edit') {
                            editProjectCostPriority();
                        } else if (option === 'Delete') {
                            setDeleteProjectCostPriorityCheck(true);
                        }
                    }
                    }>
                        {option}
                    </DropdownItem>,
                )}
            />
            <div>
                <ProjectCostPriorityEdit />
            </div>
            <SweetAlert show={deleteProjectCostPriorityCheck}
                warning
                showCancel
                confirmBtnText={<IntlMessages id="button.yesDeleteIt" />}
                cancelBtnText={<IntlMessages id="button.cancel" />}
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title={<span style={{ fontWeight: 'bold', color: 'grey', fontSize: '200%' }}><IntlMessages id="general.areYouSure" /></span>}
                onConfirm={() => {
                    deleteProjectCostPriority(projectCostPriority);
                    setDeleteProjectCostPriorityCheck(false);
                }}
                onCancel={() => {
                    setDeleteProjectCostPriorityCheck(false);
                }}
            >
                <IntlMessages id="projectCostPriority.deleteProjectCostPriority" />
            </SweetAlert>
        </div>
    );
};

export default ProjectCostPriorityRow;


// WEBPACK FOOTER //
// ./components/Agile/projectCostPriority/projectCostPriorityList/projectCostPriorityRow/index.js